import { BOverlay } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBOverlay when migrating. */
export const EgBOverlay = createEgBootstrapProxy("EgBOverlay", BOverlay);
